/* Suprimal cross-sell under the product buy box: pick strips, choose one-time or a subscription plan and a quantity, and add them (with this strip) in one tap. */
(function () {
  'use strict';
  var d = document;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function money(c) { return window.Suprimal && window.Suprimal.money ? window.Suprimal.money(c) : '$' + (c / 100).toFixed(2); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function init(root) {
    if (!root || root.__xs) return; root.__xs = 1;
    var items = qa('[data-xs-item]', root).map(function (el) {
      var sel = el.querySelector('[data-xs-plan]');
      var it = {
        el: el, id: +el.getAttribute('data-id'), price: +el.getAttribute('data-price'),
        onceUnit: el.getAttribute('data-once-unit') || '', req: el.getAttribute('data-req') === '1',
        sel: sel, plans: sel ? qa('option', sel) : [], picked: false, qty: 1, touched: false
      };
      it.mode = it.plans.length ? 'sub' : 'once';
      return it;
    });
    if (!items.length) return;

    function $(s) { return root.querySelector(s); }
    var LIMIT = +root.getAttribute('data-count') || 3;
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var FREE = (+root.getAttribute('data-free') || 0) * rate;
    var FREE_QTY = +root.getAttribute('data-free-qty') || 0, CART_QTY = +root.getAttribute('data-cart-qty') || 0, CART_LONG = root.getAttribute('data-cart-long') === '1';
    var main = {}; try { main = JSON.parse(($('[data-xs-main-json]') || {}).textContent || '{}'); } catch (e) { main = {}; }
    var form = d.querySelector('[data-sp-buybox]');
    var cart = {
      total: +root.getAttribute('data-cart-total') || 0,
      subs: +root.getAttribute('data-cart-subs') || 0,
      ids: (root.getAttribute('data-cart-ids') || '').split(',').filter(Boolean).map(Number)
    };
    var ui = {
      list: $('[data-xs-list]'), meter: $('[data-xs-meter]'), meterText: $('[data-xs-meter-text]'), bar: $('[data-xs-meter-bar]'),
      mainBox: $('[data-xs-main]'), mainRow: $('[data-xs-mainrow]'), mainDesc: $('[data-xs-main-desc]'),
      count: $('[data-xs-count]'), saveLine: $('[data-xs-save-line]'), total: $('[data-xs-total]'), was: $('[data-xs-total-was]'),
      add: $('[data-xs-add]'), cta: $('[data-xs-cta]'), meta: $('[data-xs-cta-meta]'), err: $('[data-xs-err]'), note: $('[data-xs-note]')
    };
    var CTA = ui.add.getAttribute('data-label') || 'Add to bag', NOUN = root.getAttribute('data-noun') || 'strip';
    var busy = false, justAdded = false;

    function inBag(id) { return cart.ids.indexOf(+id) > -1; }
    function find(el) { for (var i = 0; i < items.length; i++) if (items[i].el === el) return items[i]; return null; }

    /* the plan and quantity picked in the buy box above */
    function mainSel() {
      var r = form && form.querySelector('input[type=radio][name^="sp_plan_"]:checked');
      var planId = r ? r.value : '';
      var qty = +((form && form.querySelector('[data-sp-qty]')) || {}).value || 1;
      var vIn = form && form.querySelector('[name="id"]');
      var id = vIn && vIn.value ? +vIn.value : main.variant;
      var p = planId && main.plans ? main.plans[planId] : null;
      var n = p && p.per ? Math.max(1, Math.round(p.price / p.per)) : 1;
      var opt = r && r.closest ? r.closest('.sp-option') : null;
      return {
        id: id, plan: p ? planId : '', qty: qty, name: p ? p.name : '',
        price: (p ? p.price : main.price || 0) * qty, compare: (main.price || 0) * n * qty,
        label: opt ? (opt.getAttribute('data-plan') || '') : '',
        days: opt ? +opt.getAttribute('data-g') || 0 : 0
      };
    }
    function mainOn() { var m = mainSel(); return !!(ui.mainBox && ui.mainBox.checked && m.id && !inBag(m.id)); }

    function plan(it) { return it.sel ? it.sel.options[it.sel.selectedIndex] : null; }
    function unit(it) {
      var o = it.mode === 'sub' ? plan(it) : null;
      if (o) {
        var total = +o.getAttribute('data-price'), per = +o.getAttribute('data-per') || total, n = +o.getAttribute('data-n') || 1;
        return { total: total, compare: +o.getAttribute('data-compare') || total, per: per, n: n, save: +o.getAttribute('data-save') || 0, terms: o.getAttribute('data-terms') || '', plan: o.value };
      }
      return { total: it.price, compare: it.price, per: it.price, n: 1, save: 0, terms: '', plan: '' };
    }

    function paint(it) {
      var el = it.el, u = unit(it), sub = it.mode === 'sub' && !!u.plan;
      el.classList.toggle('is-picked', it.picked);
      var pick = el.querySelector('[data-xs-pick]');
      pick.setAttribute('aria-pressed', it.picked ? 'true' : 'false');
      pick.setAttribute('aria-label', (it.picked ? 'Remove ' : 'Add ') + el.getAttribute('data-title'));
      el.querySelector('[data-xs-opts]').hidden = !it.picked;
      var now = el.querySelector('[data-xs-now]'), was = el.querySelector('[data-xs-was]'), un = el.querySelector('[data-xs-unit]');
      if (sub) {
        now.innerHTML = money(u.per) + '<span>/mo</span>';
        was.textContent = u.per < it.price ? money(it.price) : '';
        un.textContent = u.n > 1 ? 'Billed ' + money(u.total) + ' / ' + u.n + ' mo' : 'Billed monthly';
      } else {
        now.textContent = money(it.price); was.textContent = ''; un.textContent = it.onceUnit;
      }
      qa('[data-xs-mode]', el).forEach(function (b) {
        var on = b.getAttribute('data-xs-mode') === it.mode;
        b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
      });
      var sv = el.querySelector('[data-xs-save]');
      if (sv) { var o = plan(it), s = o ? +o.getAttribute('data-save') : 0; sv.textContent = s > 0 ? '−' + s + '%' : ''; sv.hidden = !(s > 0); }
      var pw = el.querySelector('[data-xs-planwrap]'); if (pw) pw.hidden = it.mode !== 'sub';
      var q = el.querySelector('[data-xs-qty]'); if (q && +q.value !== it.qty) q.value = it.qty;
      var t = el.querySelector('[data-xs-terms]'); if (t) { t.textContent = sub ? u.terms : ''; t.hidden = !(sub && u.terms); }
    }

    /* until the shopper touches a strip, it follows the plan chosen above (same supply length, or one-time) */
    function mirror() {
      var m = mainSel();
      items.forEach(function (it) {
        if (it.touched || !it.plans.length) return;
        if (!m.plan && !it.req) it.mode = 'once';
        else {
          it.mode = 'sub';
          var match = m.name ? it.plans.filter(function (o) { return o.getAttribute('data-name') === m.name; })[0] : null;
          if (match) it.sel.value = match.value;
        }
      });
    }

    /* show strips that aren't in the bag first; keep anything already picked */
    function arrange() {
      var order = items.filter(function (it) { return !inBag(it.id); }).concat(items.filter(function (it) { return inBag(it.id); }));
      order.forEach(function (it, i) {
        var b = inBag(it.id);
        it.el.classList.toggle('is-inbag', b);
        var chip = it.el.querySelector('[data-xs-inbag]'); if (chip) chip.hidden = !b;
        it.el.hidden = !(i < LIMIT || it.picked);
        ui.list.appendChild(it.el);
      });
    }

    function paintMain() {
      if (!ui.mainRow) return;
      var m = mainSel(), b = inBag(m.id);
      ui.mainRow.classList.toggle('is-inbag', b);
      ui.mainBox.disabled = b;
      if (b) ui.mainBox.checked = true;
      ui.mainDesc.textContent = b ? 'Already in your bag' : (m.label || 'One-time purchase') + ' · ' + money(m.price);
    }

    function summary() {
      var n = 0, lines = 0, total = 0, compare = 0, subs = 0, isLong = false;
      items.forEach(function (it) {
        if (!it.picked) return;
        var u = unit(it);
        lines++; n += it.qty; total += u.total * it.qty; compare += u.compare * it.qty;
        if (it.mode === 'sub' && u.plan) { subs += it.qty; if (u.n >= 2) isLong = true; }
      });
      var m = mainSel(), withMain = mainOn();
      var mainPart = withMain ? m.price : 0;
      if (withMain && lines) { n += m.qty; total += m.price; compare += m.compare; if (m.plan) subs += m.qty; }

      if (ui.meter && FREE_QTY > 0) {
        /* free shipping from FREE_QTY products: what is in the bag plus what this order adds; a 60 or 90-day plan includes it */
        var qn = CART_QTY + (lines ? n : (withMain ? m.qty || 1 : 0)), qleft = FREE_QTY - qn;
        if (CART_LONG || isLong || (withMain && m.days >= 60)) { qleft = 0; qn = Math.max(qn, FREE_QTY); }
        ui.meter.hidden = false;
        ui.meter.classList.toggle('is-done', qleft <= 0);
        ui.bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, qn / FREE_QTY)).toFixed(3) + ')';
        ui.meterText.innerHTML = qleft <= 0 ? '<b>Free shipping</b> on this order' : 'Add <b>' + qleft + ' more ' + (qleft === 1 ? 'product' : 'products') + '</b> to get free shipping';
      } else if (ui.meter && FREE > 0) {
        var base = cart.total + (lines ? total : mainPart), left = FREE - base, pct = Math.max(0, Math.min(1, base / FREE));
        ui.meter.hidden = false;
        ui.meter.classList.toggle('is-done', left <= 0);
        ui.bar.style.transform = 'scaleX(' + pct.toFixed(3) + ')';
        ui.meterText.innerHTML = left <= 0 ? '<b>Free shipping</b> on this order' : 'You’re <b>' + money(left) + '</b> away from free shipping';
      }

      ui.total.textContent = money(total);
      ui.was.textContent = compare > total ? money(compare) : '';
      ui.count.textContent = lines ? plural(n, 'item', 'items') + (withMain ? ', with this ' + NOUN : '') : 'Pick one or more above';
      var save = compare - total;
      ui.saveLine.hidden = !(lines && save > 0);
      if (save > 0) ui.saveLine.innerHTML = 'You save <b>' + money(save) + '</b> with Subscribe &amp; save';
      if (ui.note) ui.note.classList.toggle('is-on', subs + cart.subs >= 2);

      ui.add.disabled = busy || !lines;
      if (justAdded) return;
      ui.cta.textContent = lines ? CTA + ' · ' + plural(n, 'item', 'items') : 'Choose a strip to add';
      ui.meta.hidden = !lines; ui.meta.textContent = money(total);
    }

    function all() { arrange(); items.forEach(paint); paintMain(); summary(); }

    function loadCart() {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var list = c.items || [];
          cart.total = c.total_price || 0;
          cart.ids = list.map(function (i) { return i.variant_id; });
          cart.subs = list.reduce(function (s, i) { return s + (i.selling_plan_allocation ? i.quantity : 0); }, 0);
          CART_QTY = list.reduce(function (s, i) { return s + (i.final_line_price > 0 && i.handle !== 'order-protection' ? i.quantity : 0); }, 0);
          CART_LONG = list.some(function (i) { var a = i.selling_plan_allocation, nm = a && a.selling_plan ? a.selling_plan.name || '' : ''; return /60|90/.test(nm); });
          all();
        })
        .catch(function () {});
    }

    /* events */
    root.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var el = t.closest('[data-xs-item]'); if (!el) return;
      var it = find(el); if (!it) return;
      var mb = t.closest('[data-xs-mode]');
      if (mb) { if (!mb.disabled) { it.mode = mb.getAttribute('data-xs-mode'); it.touched = true; paint(it); summary(); } return; }
      var st = t.closest('[data-xs-step]');
      if (st) { it.qty = Math.max(1, Math.min(10, it.qty + (+st.getAttribute('data-xs-step')))); paint(it); summary(); return; }
      if (t.closest('a, select, input, label, [data-xs-opts]')) return;
      if (t.closest('[data-xs-pick]') || t.closest('[data-xs-row]')) {
        it.picked = !it.picked; paint(it); summary();
        if (it.picked) { var f = el.querySelector('[data-xs-mode][aria-checked="true"]') || el.querySelector('[data-xs-qty]'); if (f && t.closest('[data-xs-pick]') && e.detail === 0) f.focus(); }
      }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-xs-main')) { summary(); return; }
      var el = t.closest && t.closest('[data-xs-item]'); if (!el) return;
      var it = find(el); if (!it) return;
      if (t.hasAttribute('data-xs-plan')) { it.touched = true; it.mode = 'sub'; }
      if (t.hasAttribute('data-xs-qty')) it.qty = Math.max(1, Math.min(10, parseInt(t.value, 10) || 1));
      paint(it); summary();
    });
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest && e.target.closest('[data-xs-mode]');
      if (!b || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var sib = qa('[data-xs-mode]', b.parentNode).filter(function (x) { return x !== b && !x.disabled; })[0];
      if (sib) { e.preventDefault(); sib.click(); sib.focus(); }
    });
    if (form) form.addEventListener('change', function () { setTimeout(function () { mirror(); items.forEach(paint); paintMain(); summary(); }, 0); });

    ui.add.addEventListener('click', function () {
      if (busy) return;
      var payload = [];
      items.forEach(function (it) {
        if (!it.picked) return;
        var u = unit(it), x = { id: it.id, quantity: it.qty };
        if (it.mode === 'sub' && u.plan) x.selling_plan = +u.plan;
        payload.push(x);
      });
      if (!payload.length) return;
      var m = mainSel();
      if (mainOn()) { var mx = { id: m.id, quantity: m.qty }; if (m.plan) mx.selling_plan = +m.plan; payload.unshift(mx); }
      busy = true; ui.err.hidden = true;
      ui.add.classList.add('is-loading'); ui.add.setAttribute('aria-busy', 'true'); ui.add.disabled = true;
      /* sent as a Request object so a subscription app's fetch override can't replace the plan chosen here */
      fetch(new Request(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: payload }) }))
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'We couldn’t add that to your bag. Please try again.'); return j; }); })
        .then(function () {
          items.forEach(function (it) { it.picked = false; it.qty = 1; });
          justAdded = true;
          ui.add.classList.add('is-done'); ui.cta.textContent = 'Added to your bag'; ui.meta.hidden = true;
          setTimeout(function () { justAdded = false; ui.add.classList.remove('is-done'); summary(); }, 1800);
          return loadCart().then(function () {
            if (window.SuprimalCart && d.querySelector('[data-sp-bag]')) window.SuprimalCart.refresh(true);
            else location.href = ROOT + 'cart';
          });
        })
        .catch(function (err) { ui.err.textContent = err.message; ui.err.hidden = false; })
        .then(function () { busy = false; ui.add.classList.remove('is-loading'); ui.add.removeAttribute('aria-busy'); summary(); });
    });

    /* stay in sync when the bag changes elsewhere (buy box, drawer) */
    var tm = 0;
    function soon() { clearTimeout(tm); tm = setTimeout(loadCart, 250); }
    if ('MutationObserver' in window) qa('.sp-cart-count').forEach(function (c) { new MutationObserver(soon).observe(c, { attributes: true, attributeFilter: ['data-count'] }); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });

    mirror(); all();
    root.classList.add('is-ready');
  }

  function boot() { qa('[data-sp-xs]').forEach(init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', boot);
})();